export const OpenBonusTrackIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="2 0 32 32" fill="none">
      <path d="M13 18L18 13L23 18" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
